export default __webpack_public_path__ + "static/media/logo_white.564bfb6d.png";